import { filterOptions } from '@/utils/query-base'
import { formatSapDate } from '@/mixins/index'
const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])




export default {
  'red_rush_id': {
    title: '红冲单号',
    slot: true,
  },
  'old_invo_infoid': {
    title: '原制票通知单号',
    type: 'input',
    equation: all,
    width: 140
  },
  'blue_invo_infoid': {
    title: '蓝制票单号',
    type: 'input',
  },
  'red_invo_infoid': {
    title: '红制票单号',
    type: 'input',
  },

  'old_w_invo_infoid': {
    title: '原外部制票通知单号',
    type: 'input',
    equation: all,
    width: 180
  },
  'sal_center': {
    describe: true,
    title: '营销大区',
    type: 'select',
    equation: all,
    dictionary: 'sale',
    unSearchRole: 'WLY001'
  },
  // 'sal_center_text': {
  //   title: '营销大区描述',
  //   type: 'input',
  // },
  'old_invo_id': {
    title: '原发票号',
    type: 'input',
  },
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    },
    unSearchRole: 'WLY001'
  },
  'cust_name': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 200,
    unSearchRole: 'WLY001'
  },
  'status': {
    describe: true,
    title: '红冲单状态',
    type: 'select',
    equation: city,
    dictionary: 'A0084',
    width: 130
  },
  // 'status_text': {
  //   title: '红冲单状态描述',
  //   type: 'input',
  // },
  'description': {
    title: '产品名称',
    type: 'input',
  },
  'ordered_prod': {
    title: '产品编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品编码'
    },
  },
  'use_zzfld9': {
    title: '件数',
    type: 'input',
    xlsxFmt: {
      t: 'n'
    }
  },
  // 'use_bot': {
  //   title: '瓶数',
  //   type: 'input',
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  'deliver_qty': {
    title: '已审核数量',
    type: 'input',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zc_deliver_qty': {
    title: '总仓发货数量',
    type: 'input',
    xlsxFmt: {
      t: 'n'
    }
  },
  'fc_deliver_qty': {
    title: '分仓发货数量',
    type: 'input',
    xlsxFmt: {
      t: 'n'
    }
  },
  'uname': {
    title: '创建人',
    type: 'input',
  },
  'uname_text': {
    title: '创建人名称',
    type: 'input',
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    equation: all,
    width: 140,
    defaultVal: new Date()
  },
  'remark': {
    title: '备注',
    type: 'input',
  },

  // 'zzfld00003e': {
  //   describe: true,
  //   title: '基地',
  //   type: 'select',
  //   equation: all,
  //   dictionary: 'base',
  //   unSearchRole: 'WLY001'
  // },
  // 'inv_amount': {
  //   title: '发票金额',
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'inv_type': {
  //   describe: true,
  //   title: '发票类型',
  //   type: 'select',
  //   equation: city,
  //   dictionary: 'A0032'
  // },
  // 'chan_date': {
  //   title: '换票日期',
  //   type: 'date',
  //   equation: all
  // },

  // 'inf_type': {
  //   describe: true,
  //   title: '制票通知单类型',
  //   type: 'select',
  //   equation: city,
  //   dictionary: 'A0022',
  //   width: 150
  // },
  // 'inv_status': {
  //   describe: true,
  //   title: '制票通知单状态',
  //   type: 'select',
  //   equation: city,
  //   dictionary: 'A0033',
  //   width: 130
  // },
  // 'mark_print': {
  //   title: '是否已打印',
  //   type: 'whether',
  //   equation: be,
  //   formatter: ({ cellValue }) => cellValue ? '是' : ''
  // },
  // 'zzfld00002d_dscr': {
  //   title: '创建人',
  //   type: 'input',
  //   equation: cusname
  // },
  // 'remark': {
  //   title: '制票通知单表头备注',
  //   type: 'input',
  //   equation: cusname
  // },
  // 'zzfld00002j': {
  //   describe: true,
  //   title: '运达方类型',
  //   type: 'select',
  //   equation: city,
  //   dictionary: 'A0009'
  // },
  // 'zzfld00008t': {
  //   title: '运达方编码',
  //   type: 'dialog',
  //   equation: all,
  //   dialog: {
  //     component: 'ClientSelect',
  //     title: '运达方编码'
  //   }
  // },
  // 'zzfld00008t_dscr': {
  //   title: '运达方名称',
  //   type: 'input',
  //   equation: cusname,
  //   width: 200
  // },
  // 'recinv_pers': {
  //   title: '收票联系人',
  //   type: 'input',
  //   equation: cusname
  // },
  // 'recinv_tel': {
  //   title: '联系电话',
  //   type: 'input',
  //   equation: cusname
  // },
  // 'inv_addr': {
  //   title: '收票地址',
  //   type: 'input',
  //   equation: cusname,
  //   width: 200
  // },
  // 'datum': {
  //   title: '创建日期',
  //   type: 'date',
  //   equation: cusname,
  //   formatter: ({ cellValue }) => formatSapDate(cellValue)
  // }
}



// WEBPACK FOOTER //
// ./src/views/invoice-manage/config/redOrderList.js